
import styled from "styled-components"
import { GoogleMap, useLoadScript, Marker, DirectionsRenderer, DirectionsService } from "@react-google-maps/api"
import { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import { setRouteDistance } from "../../../features/updateLoad/updateLoadSlice"

const Container = styled.div`
    width: 100%;


`

const GivenMapSection = ({defaultLocation,  route, zoom}) => {

  const dispatch = useDispatch()

    const [directionsResponse, setDirectionsResponse] = useState(null)
    const [map, setMap] = useState(null);

    const {isLoaded} = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    })


    const rotaOptions = {
        polylineOptions: {
          strokeColor: "#2855F5", // Rota rengi
          strokeOpacity: 1,
          strokeWeight: 3
        },
    }

    const onLoad = (mapInstance) => {
        setMap(mapInstance);
      };

      useEffect(() => {
        if (map) {
          const mapCenter = new window.google.maps.LatLng(defaultLocation.lat, defaultLocation.lng);
          map.panTo(mapCenter); // Marker'ın bulunduğu bölgeye odaklanmak için panTo kullanıyoruz
        }
    },[map])

    const  options = {
        zoomControl: false, // Zoom butonlarını kaldırır
        // fullscreenControl: false, // Tam ekran kontrolünü kaldırır
        streetViewControl: false, // Sokak görünümü kontrolünü kaldırır
        scaleControl: false, // Ölçek kontrolünü kaldırır
        mapTypeControl: false, // Harita türü kontrolünü kaldırır
        rotateControl: false, // Döndürme kontrolünü kaldırır
        // panControl: false, // Kaydırma kontrolünü kaldırır
      }

      useEffect(()=> {
        if(map && route?.length > 1){
            calculateRoute(route)
        }
        else{
          setDirectionsResponse(null)
        }
    },[map, route])


    const calculateRoute = async(route) => {

        const origin = route[0]
        const destination = route[route.length-1]
        const wayPoints = route.slice(1, route.length - 1);
        
          // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService()
        const results = await directionsService.route({
          origin: origin,
          destination: destination,
          // eslint-disable-next-line no-undef
          travelMode: google.maps.TravelMode.DRIVING,
    
          waypoints: wayPoints.length > 0 ? wayPoints : null 
        })
        setDirectionsResponse(results)

        dispatch(setRouteDistance(results.routes[0].legs.reduce((accumulator, item) =>  {
          return accumulator + parseFloat(item.distance.text.replace(".", ""))
      },0)))
    }

    if(!isLoaded){
        return <div>loading</div>
    }

  return (
    <Container>
            <GoogleMap zoom={zoom}  mapContainerClassName='map-container' onLoad={onLoad} options={options}>
            {
                directionsResponse && (
                    <DirectionsRenderer directions={directionsResponse} options={rotaOptions}  />
                )
            }
    </GoogleMap>
    </Container>
  )
}

export default GivenMapSection